import agent from "../api/agent";

export const getOutlets = async () => {
  return await agent.Outlets.getOutlets();
}
